import 'react-dates/initialize';
import React from 'react';  
import { connect } from 'react-redux'
import { Container } from 'react-bootstrap'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'
import Form from 'react-bootstrap/Form'
import Card from 'react-bootstrap/Card'
import $ from 'jquery'
import moment from 'moment';  
import { ACT_SELECTPERIOD } from './actions.js';
import { WL} from './WebLoggerService.jsx'
import './css/Report.css';
import TooltipButton from './TooltipButton.jsx'



class Report extends React.Component {  

	constructor(props) {
		super(props)
		//this.GetProjectsResult = this.GetProjectsResult.bind(this)
		this.getReport = this.getReport.bind(this)
		this.state = { recentProjects: [], projectId:0}
	}
	
	componentDidMount() {
		
		//$('input[name="dates"]').click();
		$('.ButtonColumn').addClass("align-self-center").css("padding","0px");
		$('.ButtonRow').addClass("m-1").css({padding: "0px"});
		//$('.periodSelector').css("width","100%");
		//$('.generateButton').css("width","100%");

		//if (this.state.recentProjects.length === 0) {
		//	WL.GetProjects(this.props.token, "user", this.GetProjectsResult, {})
		//}
		this.constructState()
	}
	constructState() {
		console.log("constructing state for report");
	//GetProjectsResult(result, recentProjects, token) {
		//if (result === WL_UNAUTHORIZED) {
		//	this.props.logout()
		//} else if (result === WL_EXCEPTION) {
		//	this.setState({ showError: true, errMsg: "Failed to contact the server" })
		//} else if (result === WL_FAIL) {
		//	this.setState({ showError: true, errMsg: "Failed to retrieve the recent projects" })
		//} else if (result === WL_SUCCESS) {
			//console.log("Got recent projects")
			let lst=[]
			this.props.recentProjects.forEach(prj => { lst.push(<option key={prj.id} value={prj.id}>{prj.name}</option>) })
			let projectId = 0
			if (this.props.recentProjects.length > 0) projectId = this.props.recentProjects[0].id

			console.log("jobdayinfo:")
			console.log(this.props.jobDayInfo)

			let jobPeriods = []
			let jobPeriod

			this.props.jobDayInfo.forEach(jdi => {

				jobPeriods.push(<option key={jdi.idField} value={jdi.idField}>{moment(jdi.periodFromField).format("DD/MM/YYYY") + " till " + moment(jdi.periodTillField).format("DD/MM/YYYY")}</option>)

				if (moment().isBetween(moment(jdi.periodFromField), moment(jdi.periodTillField))) {
					this.props.setPeriod(moment(jdi.periodFromField), moment(jdi.periodTillField))
					jobPeriod = jdi.idField
                }
			})
			

			this.setState({ recentProjects: lst, projectId, jobPeriods, jobPeriod })

		//}
	}

	selectJobPeriod(jobPeriod) {
		console.log("new period selected")
		this.props.jobDayInfo.forEach(jdi => {
			if (jdi.idField === jobPeriod) {
				this.props.setPeriod(moment(jdi.periodFromField), moment(jdi.periodTillField))
				this.setState({ jobPeriod })
			}
		})
    }
	
		
		
	getReport(event) {
		event.preventDefault()
		var startDate = (this.props.startDate === null ? moment() : this.props.startDate)
		var endDate = (this.props.endDate === null ? startDate : this.props.endDate)
		var projectId = undefined
		if (this.props.type === "summaryreport") {
			if (moment().isBefore(endDate)) {
				endDate = moment().startOf("day");
			}
		}
		if (this.props.type === "expertstimesheet") {
			projectId = this.state.projectId;
		}
		
		WL.OpenReport(this.props.token, this.props.type, startDate, endDate, projectId)
		console.log("Report Requested with projectid="+projectId);
	}
	
	
    
	render() {  
	
		let title;
		switch (this.props.type){
			case "holiday": title="Holiday Report"; break; 
			case "distance": title="Compensation Report"; break;
			case "logging": title="Log Report"; break;
			case "expertstimesheet": title = "Timesheet"; break;
			case "summaryreport": title = "Summary Report"; break;
			case "adv": title="ADV Rapport"; break;
			default: title = "Ongekend rapport"; break;
		}

		let period = "";
		if (this.props.endDate===null || this.props.startDate.startOf("day").isSame(this.props.endDate.startOf("day")))
			period += "For " + this.props.startDate.format("DD/MM/YYYY")
		else
			period += "From " + this.props.startDate.format("DD/MM/YYYY") + " until " + this.props.endDate.format("DD/MM/YYYY")
				
		return (  
			<Container>
				<div className="reportbuttons mx-auto" >
					<Row className="m-1 justify-content-md-center" >
						<Col className="ButtonColumn" >
							<Form onSubmit={this.getReport}>
								<Card style={{ backgroundColor: 'rgba(0, 0, 0, 0.1)' }}>
									<Card.Header>
										<Card.Title>{title}</Card.Title>
									</Card.Header>
									<Card.Body >
										{(this.props.type !== "summaryreport") && <Row className="justify-content-md-center" style={{ fontSize: 20 }}>{period}</Row>}
										{
											(this.props.type === "expertstimesheet") &&
											<Row className="justify-content-md-center" >
												<Form.Group controlId="reportForm.ProjectItem" >
													<Form.Label>Select the project for the report</Form.Label>
													<Form.Control as="select" onChange={(event) => { this.setState({ projectId: parseInt(event.target.value) }); }} required value={this.state.projectId}>
														{/*this.state.recentProjects*/
															this.props.recentProjects.map(prj => <option key={prj.id} value={prj.id}>{prj.name}</option>)}
													</Form.Control>
												</Form.Group>
											</Row>
										}
										{
											(this.props.type === "summaryreport") &&
											<Row className="justify-content-md-center" >
												<Form.Group controlId="reportForm.JobPeriod" >
													<Form.Label>Select the period for the report</Form.Label>
													<Form.Control as="select" onChange={(event) => { this.selectJobPeriod(parseInt(event.target.value))}} required value={this.state.jobPeriod}>
														{this.state.jobPeriods}
													</Form.Control>
												</Form.Group>
											</Row>
										}
									</Card.Body>
									<Card.Footer>
										<Row className="ButtonRow  justify-content-md-center" >
											<TooltipButton className="generateButton mx-auto" variant="outline-light" tooltiptext={"Generate " + title} type="submit" content={<Image alt="generate report" src="note.png" style={{ width: "64px" }} />} />
										</Row>
									</Card.Footer >
								</Card >
							</Form>
						</Col>
					</Row>		
				</div>
			</Container>
			
        );  
    }  
}  

function mapDispatchToProps(dispatch) {
	return {
		setPeriod: (startDate, endDate) => { dispatch({ type: ACT_SELECTPERIOD, startDate, endDate }) }
	}

}

function mapStateToProps(state) {
	var startDate = state.period.startDate === null ? null : moment(state.period.startDate)
	var endDate = state.period.endDate === null ? null : moment(state.period.endDate)

	
	return { startDate, endDate, token: state.user.userInfo["token"], jobDayInfo: state.user.jobDayInfo, recentProjects: state.projects.recentProjects }
}

  
export default connect(mapStateToProps, mapDispatchToProps)(Report);  